module.exports = __webpack_public_path__ + "static/media/food-insecurity-xl.9fd4c2d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/food-insecurity-xl.jpg
// module id = 410
// module chunks = 12